<!-- 新建页面 -->
<template>
  <div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="500px"
      @close="closeChild"
      :before-close="handleClose"
      center
      title="操作选择"
      append-to-body
    >
      <div>
        <el-alert title="操作成功！请选择您要执行的操作" type="success">
        </el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="drawerCancel">返回列表</el-button>
        <el-button type="primary" @click="conAdd">继续新增</el-button>
        <el-button type="primary" @click="showPrintPlan">打印</el-button>
      </span>
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "operSelect",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      centerDialogVisible: false,
      pathInfo: {},
      orderId: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    closeChild(){
      // this.$emit("drawerCancel");
    },
    openBox(orderId) {
      this.orderId = orderId;
      this.pathInfo = parent.getMenuInfo(this.$route.path);
      this.centerDialogVisible = true;
    },
    drawerCancel() {
      this.centerDialogVisible = false;
      this.$emit("drawerCancel");
    },
    handleClose(){
      this.centerDialogVisible = false;
      this.$emit("drawerCancel");
    },
    conAdd() {
      this.centerDialogVisible = false;
      this.$emit("conAdd");
    },
    // 打印方法
    showPrintPlan() {
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.orderId,
          this.pathInfo.printSource,
          this.pathInfo.jurId
        );
      } else {
        return;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
</style>
